module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-13be13.9a7af96a.png";